import {makeEl} from "../../common/Utils";
import DataStore from "../DataStore";
import {svgIcoBtnChange, svgIcoChangeList} from "../SvgCode";
import Layer from "../Layer";

export default  class Country{
    private ds: DataStore;
    private btn!: HTMLButtonElement;
    private ul!: HTMLUListElement;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.countryList.length> 0){
            this.templ(_wrapper);
            this.addEvents();
        }
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-change-inner footer-change-country'})
        this.btn = makeEl('button', tmpl, {class: 'btn-footer-change'});

        this.btn.innerHTML= `
            <span class="inner-txt">${this.ds.l10n.country[this.ds.country]}</span>
            ${svgIcoBtnChange}
        `
        this.ul = makeEl('ul', tmpl, {class: 'footer-change-list', id: 'FooterCountryChangeList'})
        this.ds.countryData.map(it => this.liTempl(this.ul, it, svgIcoChangeList));
        if(this.ds.country === "NC"){
            this.liTempl(this.ul, {country: 'global', text: 'Global'}, svgIcoChangeList)
        }
    }

    liTempl(_parent: HTMLUListElement, _data: {country: string, text: string}, _svgCode: string){
        const li = makeEl('li', _parent, {class: 'footer-change-item'});
        const aEl = makeEl('a', li, {class: 'change-item-link', href: this.makeLink(_data.country), 'data-country': _data.country});

        if(_data.country === this.ds.country){
            aEl.innerHTML= _svgCode;
            makeEl('strong', aEl, undefined, _data.text);
        }
        else{
            makeEl('span', aEl, undefined, _data.text);
        }
    }

    makeLink(_country: string): string{
        let newCountry = _country.toLowerCase();
        let link = '/'+ newCountry + '/index';
        if(this.ds.config.keepPath){
            const reg = new RegExp(`^\/${this.ds.country.toLowerCase()}\/`, 'gi');
            const result = location.pathname.match(reg);
            if (result){
                link = `/${newCountry}${location.pathname.slice(3)}${location.search}${location.hash}`;
            }
            else{
                link = `/${newCountry}${location.pathname}${location.search}${location.hash}`;
            }
        }
        return link;
    }

    addEvents() {
        this.btn.addEventListener('click', e => {
            Layer.toggleLayer(this.ul.id);
            e.stopPropagation();
        });
    }
}